import { styled } from '@mui/material/styles';

export const Video = styled('video')`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: cover;
  pointer-events: none;
  /* Own dark background so the fallback is self-contained: with preload="none"
     no frame is fetched until play() runs, and if autoplay is blocked no frame
     is ever painted. This fills the element with the intended dark backdrop for
     the overlaid white text instead of relying on the parent wrapper's bgcolor. */
  background-color: ${(p) => p.theme.palette.common.black};
`;
